import React, { useState } from 'react'
import { CircularProgress } from '@material-ui/core'
import { Page, Header, CustomTable } from 'components'
import moment from 'moment'
import localization from 'moment/locale/pt-br'
import VisibilityIcon from '@material-ui/icons/Visibility'
import useRouter from 'utils/useRouter'
import { Filtros } from './Filtros'
import useStyles from './styles'

export const Requisicoes = (props) => {
  moment.locale('pt-br', localization)
  const { route } = props
  const router = useRouter()
  const [processandoRequisicao, setProcessandoRequisicao] = useState(false)
  const classes = useStyles()
  const [requisicoes, setRequisicoes] = useState([])

  const handleClickVisualizarPaginaRequisicao = (rowData) => {
    router.history.push(`/requisicoes/requisicao/detalhar/${rowData.id}`)
  }

  return (
    <Page className={classes.root} title={`${route.titulo} - SIGEP`}>
      <Header titulo={route.titulo} overline={route.secao} />
      <Filtros setRequisicoes={setRequisicoes} setProcessandoRequisicao={setProcessandoRequisicao} />
      <CustomTable
        localization={{
          body: {
            emptyDataSourceMessage: processandoRequisicao ? <CircularProgress disableShrink /> : 'Nenhuma requisição encontrada',
          },
          header: {
            actions: 'Ações',
          },
        }}
        title=""
        columns={[
          {
            title: 'Identificador',
            render: (rowData) => rowData.identificador?.toUpperCase() || 'NÃO INFORMADO',
          },
          {
            title: 'RIP',
            render: (rowData) => rowData.identificador_caso_rip?.toUpperCase() || 'NÃO INFORMADO',
          },
          {
            title: 'Orgão',
            render: (rowData) => rowData.orgaoOrigem?.nome?.toUpperCase() || 'NÃO INFORMADO',
          },
          {
            title: 'Setor Solicitante',
            render: (rowData) => rowData.setorSolicitante?.nome?.toUpperCase() || 'NÃO INFORMADO',
          },
          {
            title: 'Status',
            render: (rowData) => rowData.status?.toUpperCase().replace(/_/g, ' ') || 'NÃO INFORMADO',
          },
          {
            title: 'Data de Cadastro',
            render: (rowData) => moment(rowData.createdAt).format('LLLL').toUpperCase(),
          },
          {
            title: 'Tipo Específico',
            render: (rowData) => rowData.tipo_especifico?.toUpperCase().replace(/_/g, ' ') || 'NÃO INFORMADO',
          },
        ]}
        data={requisicoes}
        actions={[
          {
            icon: VisibilityIcon,
            tooltip: 'Visualizar página da requisição',
            onClick: (event, rowData) => handleClickVisualizarPaginaRequisicao(rowData),
          },
        ]}
        options={{
          actionsColumnIndex: -1,
          search: true,
          searchFieldPlaceholder: 'Buscar requisições...',
          pageSize: 20,
        }}
      />
    </Page>
  )
}
